// No reports endpoints exist on the backend yet — this module ships as a
// static scaffold (matching the Payout/RewardAds pages' convention) with
// generated mock data, ready to be swapped for real API calls once the
// contract exists.

import dayjs from 'dayjs'

export const REPORT_CAMPAIGN_OPTIONS = [
  { label: 'Campaign name 1', value: 'campaign-1' },
  { label: 'Campaign name 2', value: 'campaign-2' },
  { label: 'Campaign name 3', value: 'campaign-3' },
  { label: 'Campaign name 4', value: 'campaign-4' }
]

const ROWS = [
  { type: 'performance', typeLabel: 'Performance', name: 'Performance Report', subtitle: 'Overall performance & KPIs', format: 'pdf', status: 'completed', campaignValue: 'campaign-1', generatedOn: '2026-08-13', generatedAt: '9:15 AM' },
  { type: 'performance', typeLabel: 'Performance', name: 'Performance Report', subtitle: 'Overall performance & KPIs', format: 'xlsx', status: 'completed', campaignValue: 'campaign-2', generatedOn: '2026-08-01', generatedAt: '11:40 AM' },
  { type: 'campaign', typeLabel: 'Campaign', name: 'Campaign Report', subtitle: 'Detailed campaign performance', format: 'csv', status: 'completed', campaignValue: 'campaign-1', generatedOn: '2026-07-20', generatedAt: '4:05 PM' },
  { type: 'audience', typeLabel: 'Audience', name: 'Audience Report', subtitle: 'Viewer demographics and insights', format: 'pdf', status: 'processing', campaignValue: 'campaign-3', generatedOn: '2026-07-05', generatedAt: '8:52 AM' },
  { type: 'location', typeLabel: 'Location', name: 'Location Report', subtitle: 'Performance by location', format: 'pdf', status: 'completed', campaignValue: 'campaign-2', generatedOn: '2026-06-16', generatedAt: '9:15 AM' },
  { type: 'device', typeLabel: 'Device', name: 'Device Report', subtitle: 'Performance by devices', format: 'xlsx', status: 'completed', campaignValue: 'campaign-4', generatedOn: '2026-05-15', generatedAt: '2:30 PM' },
  { type: 'daily_summary', typeLabel: 'Daily Summary', name: 'Daily Summary', subtitle: 'Day by day performance summary', format: 'pdf', status: 'failed', campaignValue: 'campaign-1', generatedOn: '2026-04-02', generatedAt: '6:00 AM' }
]

export function getMockRecentReports() {
  return ROWS.map((row, index) => {
    const generated = dayjs(row.generatedOn)

    return {
      id: `RPT-${String(1000 + index).padStart(5, '0')}`,
      ...row,
      periodLabel: `${generated.subtract(30, 'day').format('MMM D')} - ${generated.format('MMM D, YYYY')}`,
      generatedOnLabel: generated.format('MMM D, YYYY'),
      generatedOnISO: row.generatedOn
    }
  })
}
